import { TextField as KobalteTextField } from "@kobalte/core/text-field"
import type { ComponentProps } from "solid-js"
import {
  textFieldClass,
  textFieldDescriptionClass,
  textFieldErrorMessageClass,
  textFieldInputClass,
  textFieldLabelClass,
} from "./textField.css"

export function TextField(props: ComponentProps<typeof KobalteTextField>) {
  return <KobalteTextField {...props} class={textFieldClass} />
}

function TextFieldLabel(props: ComponentProps<typeof KobalteTextField.Label>) {
  return <KobalteTextField.Label {...props} class={textFieldLabelClass} />
}

function TextFieldInput(props: ComponentProps<typeof KobalteTextField.Input>) {
  return <KobalteTextField.Input {...props} class={textFieldInputClass} />
}

function TextFieldTextArea(
  props: ComponentProps<typeof KobalteTextField.TextArea>,
) {
  return <KobalteTextField.TextArea {...props} class={textFieldInputClass} />
}

function TextFieldDescription(
  props: ComponentProps<typeof KobalteTextField.Description>,
) {
  return (
    <KobalteTextField.Description
      {...props}
      class={textFieldDescriptionClass}
    />
  )
}

function TextFieldErrorMessage(
  props: ComponentProps<typeof KobalteTextField.ErrorMessage>,
) {
  return (
    <KobalteTextField.ErrorMessage
      {...props}
      class={textFieldErrorMessageClass}
    />
  )
}

TextField.Label = TextFieldLabel
TextField.Input = TextFieldInput
TextField.TextArea = TextFieldTextArea
TextField.Description = TextFieldDescription
TextField.ErrorMessage = TextFieldErrorMessage
